import { FC, useEffect, useState } from "react";
import { Route, useHistory } from "react-router-dom";

import { Authorization, useAuthorization } from "../../common/AuthorizationCpt";
import IconArrowRight from "../../images/icon_arrow_right.svg";

import { ImportFlowScreens } from "../../utils/constants";
import { ADMIN_ROUTES } from "../../utils/routeConstants";
import { BillingScreenAdmin } from "../BillingScreenAdmin/BillingScreenAdmin";
import { PaymentPaidAdminResource } from "../PaymentAdmin/Paid/PaymentPaidAdminResource";
import {
  StepContent,
  StepDescription,
  StepNumber,
  StepsBar,
} from "../Steps/StepsStyles";

import { Header, MainContainer } from "./BillingStyles";

const STEPS = {
  pedidos: {
    description: "Simular cotización",
    screenName: ImportFlowScreens.ORDERS,
    path: ADMIN_ROUTES.ORDERS.path,
    code: "quotation",
    authorization: ["dam.get_dam_estimate_backoffice"],
  },
  pagos: {
    description: "Consultar facturas",
    screenName: ImportFlowScreens.PAYMENT,
    path: ADMIN_ROUTES.PAYMENT.path,
    code: "payment",
    authorization: ["quotation.get_quotation_paid_backoffice"],
  },
};

interface IBillingAdmin {
  userInfo: any;
}

export const BillingAdmin: FC<IBillingAdmin> = (props) => {
  const { userInfo } = props;
  const history = useHistory();
  const authorization = useAuthorization();

  const [steps] = useState(() => {
    const steps = Object.keys(STEPS)
      .map((key) => STEPS[key])
      .filter((step) => {
        return authorization.isAllowedByActions(step.authorization);
      });

    return steps;
  });
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const unsub = history.listen((location) => {
      const index = steps.findIndex((step) =>
        location.pathname.startsWith(step.path)
      );
      setCurrentIndex(index);
    });

    const index = steps.findIndex((step) =>
      history.location.pathname.startsWith(step.path)
    );
    setCurrentIndex(index);

    return () => {
      unsub();
    };
  }, [steps, history]);

  return (
    <div>
      <Header>
        <StepsBar>
          <h1>{ADMIN_ROUTES.BILLING_USERS_ADMIN.title.toUpperCase()}</h1>
          <div className="step-tabs">
            {steps.map((step, index) => {
              return (
                <BillingStep
                  key={index}
                  onClick={() => {
                    history.push(step.path);
                  }}
                  index={index}
                  step={{ description: step.description }}
                  isCurrent={index === currentIndex}
                />
              );
            })}
          </div>
        </StepsBar>
      </Header>

      <MainContainer>
        <Authorization actions={STEPS.pedidos.authorization}>
          <Route path={ADMIN_ROUTES.ORDERS.path}>
            <BillingScreenAdmin userInfo={userInfo} />
          </Route>
        </Authorization>
        <Authorization actions={STEPS.pagos.authorization}>
          <Route path={ADMIN_ROUTES.PAYMENT.path}>
            <PaymentPaidAdminResource />
          </Route>
        </Authorization>
      </MainContainer>
    </div>
  );
};

const BillingStep = (props) => {
  const { onClick, index, step, isCurrent } = props;
  const stepsInfo = [];
  return (
    <StepContent className="step-name">
      <StepNumber activated={isCurrent} onClick={onClick}>
        {index + 1}
      </StepNumber>
      <div onClick={onClick} onKeyDown={() => {}} role="button">
        <StepDescription isCurrent={isCurrent}>
          {step.description}
        </StepDescription>
      </div>
      <div className="arrowIcon">
        {index === stepsInfo.length - 1 ? null : (
          <img src={IconArrowRight} alt="arrowRight" />
        )}
      </div>
    </StepContent>
  );
};
